<div class="conn-card">
    <app-report-top-filter-bar  *ngIf="0==0"
        [paraReportName]="'tender-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (exportCsvFn)="dt.exportCSV()"
    ></app-report-top-filter-bar>
    <br />
    <p-table [value]="dataList" dataKey="name" #dt [columns]="csvcols" styleClass="p-datatable-striped" [tableStyle]="{'table-layout':'fixed'}" *ngIf="dataList?.length>0">
        <ng-template pTemplate="colgroup">
            <colgroup>
                <col style="width: 24%" />
                <col style="width: 24%" />
                <col style="width: 17%" />
                <col style="width: 17%" />
                <col style="width: 18%" />
            </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align: left; vertical-align: middle"><strong>Location Name</strong></th>
                <th style="text-align: left; vertical-align: middle"><strong>Payment Method</strong></th>
                <th style="text-align: right; vertical-align: middle"><strong>Invoice Count</strong></th>
                <th style="text-align: right; vertical-align: middle"><strong>Payment Method Count</strong></th>
                <th style="text-align: right; vertical-align: middle"><strong>Total Sales</strong></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-expanded="expanded">
            <tr *ngFor="let order of product.paymentMethodSales">
                <td style="text-align: left; vertical-align: middle">{{ product.locationName }}</td>
                <td style="text-align: left; vertical-align: middle">{{ order.paymentMethod }}</td>
                <td style="text-align: right; vertical-align: middle">{{ order.invoiceCount }}</td>
                <td style="text-align: right; vertical-align: middle">{{ order.paymentMethodCount }}</td>
                <td style="text-align: right; vertical-align: middle">{{ order.totalSales | currency | currencySpacing }}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="footer">
            <tr *ngIf="dataList?.length > 0">
                <td colspan="2" style="text-align: left; vertical-align: middle"><strong>Total</strong></td>
                <td *ngFor="let col of domSummaryflds" style="text-align: right; vertical-align: middle">{{ calculateSummaryTotal(col) | currencySpacing }}</td>
            </tr>
        </ng-template>
    </p-table>
    <div class="flex" *ngIf="dataList?.length==0">
        <div class="flex justify-content-center" style="width: 100%">
            <span class="control-description text-muted text-align-center"> No data found!</span>
        </div>
    </div>

</div>
